import * as Clipboard from 'expo-clipboard';
import { buildRedirectURL } from './deep-link';

/**
 * Artifacts are always referenced by the owned app route, never by a storage
 * URL: the route checks ownership and mints a fresh link each time it opens.
 */
export function artifactRoute(artifactId: string, kind?: string, view?: 'preview' | 'code') {
  const path = `/artifacts/${encodeURIComponent(artifactId)}`;
  // The kind lets the native route pick the image lightbox (no header) before
  // the artifact has loaded; the shared link never carries it. A building
  // card's Open asks for the page's code (plan 7.2).
  const query = [
    ...(kind ? [`kind=${encodeURIComponent(kind)}`] : []),
    ...(view === 'code' ? ['view=code'] : []),
  ];
  return query.length ? `${path}?${query.join('&')}` : path;
}

/** The absolute link Copy link puts on the clipboard (https on every platform). */
export function artifactShareUrl(artifactId: string) {
  return buildRedirectURL(artifactRoute(artifactId));
}

/** Resolves false when the clipboard refused, so the caller never claims success. */
export async function copyArtifactLink(artifactId: string): Promise<boolean> {
  try {
    await Clipboard.setStringAsync(artifactShareUrl(artifactId));
    return true;
  } catch {
    return false;
  }
}
